"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Parentdiv = styled_components_1.default.div `
  height: ${(props) => props.height}px;
  margin: ${(props) => props.margin ? props.margin : "unset"};
  width: 100%;
  background-color: ${(props) => props.bgcolor};
  border-radius: 20px;
`;
const Childdiv = styled_components_1.default.div `
  height: 100%;
  width: ${(props) => props.progress ? props.progress : 100}%;
  background-color: ${(props) => props.pgcolor};
  border-radius: 20px;
`;
const ProgressBar = ({ pgcolor, bgcolor, progress, height, className = "", margin = "" }) => {
    return (react_1.default.createElement(Parentdiv, { height: height, bgcolor: bgcolor, className: className, margin: margin },
        react_1.default.createElement(Childdiv, { progress: progress, pgcolor: pgcolor })));
};
exports.default = ProgressBar;
